module.exports = "attribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\n\nuniform mat3 projectionMatrix;\nuniform mat3 otherMatrix;\n\nvarying vec2 vTextureCoord;\nvarying vec2 vFilterCoord;\n\nvoid main(void)\n{\n   gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n   vTextureCoord = aTextureCoord;\n   vFilterCoord = ( otherMatrix * vec3( aTextureCoord, 1.0)  ).xy;\n}\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/glsl/fragments/default-filter-matrix.glsl
 ** module id = 316
 ** module chunks = 2
 **/